module.exports = __webpack_public_path__ + "media/customizations/paintedprairie/logo-3b27ceaa7ffbdf0291941c5559286a42.png";